<template>
  <div class="catalog_module">
    <div class="search flex">
      <span class="tit">欢迎页管理</span>
      <div class="flex">
        <el-button size="mini" class="addBtn" @click="editItem(0)">新增</el-button>
      </div>
      </div>
    <div class="instrument">
      <el-table
          :data="list"
      >
        <el-table-column
          align="center"
          prop="itemName"
          label="作者"
          width="200"
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column
            align="center"
            prop="itemDesc"
            label="内容"
            show-overflow-tooltip>
        </el-table-column>
        <el-table-column
            align="center"
            prop="status"
            label="状态"
            width="100"
            show-overflow-tooltip>
          <template slot-scope="{ row }">
            <el-tag v-if="row.status===0" type="danger" @click="changeStatus(row)">
              禁用
            </el-tag>
            <el-tag v-else-if="row.status===1" type="success" @click="changeStatus(row)">
              启用
            </el-tag>
            <el-tag v-else>
              -
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
            align="right"
            fixed="right"
            width="130">
          <template slot-scope="scope">
            <el-button size="mini" type="text" class="btn" @click="toDelete(scope.row)">删除</el-button>
            <el-button size="mini" type="text" class="btn" @click="editItem(scope.row)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-drawer
        :visible.sync="editDialog.visible"
        :wrapperClosable="false" :show-close="false"
        :title="(editDialog.mode==='add'?'新增':'编辑')+'子项'"
        size="700px" class="drawerCommon">
      <el-form :model="curItem" label-suffix="：" label-width="90px" class="maxHeight">
        <el-form-item label="作者">
          <el-input v-model="curItem.itemName" show-word-limit maxlength="20"></el-input>
        </el-form-item>
        <el-form-item label="中文">
          <el-input type="textarea" rows="4" v-model="curItem.itemDesc" show-word-limit maxlength="70"></el-input>
        </el-form-item>
        <el-form-item label="英文">
          <el-input type="textarea" rows="4" v-model="curItem.itemCode" show-word-limit maxlength="100"></el-input>
        </el-form-item>
        <el-form-item label="排序" v-if="editDialog.mode!=='add'">
          <el-input-number v-model="curItem.sort" :step="1" step-strictly></el-input-number>
        </el-form-item>
      </el-form>
      <div class="footer">
        <el-button size="small" type="primary" @click="saveItem">保存</el-button>
        <el-button size="small" @click="editDialog.visible=false">取消</el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import base from "@/api/common";
export default {
  name: "doctorQuotationList",
  data() {
    return {
      list: [],
      editDialog: {
        visible: false,
        mode: 'add',
      },
      curItem: {
        id: '',
        itemName: '',
        itemDesc: '',
        itemCode: '',
        sort: 0,
      },
      curDict: {},
    }
  },
  mounted() {
    this.$ajax(base.api.dict.edit.getByCode.replace("{code}", "doctor_quotation")).then((res) => {
      if (res.data.status === "success") {
        this.curDict = res.data.data;
      }
    })
    this.getData()
  },
  methods: {
    getData() {
      this.$ajax(base.api.dict.edit.item.listByCode.replace("{code}", "doctor_quotation")).then((res) => {
        if (res.data.status === "success") {
          this.list = res.data.list;
        }
      })
    },
    //删除
    toDelete(obj) {
      let that = this;
      this.$confirm("确认删除吗?", "提示", {
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$ajax.get(base.api.dict.edit.item.delete.replace("{id}", obj.id)).then((res) => {
          if (res.data.status === 'success') {
            that.getData();
            that.$message.success("操作成功");
          } else {
            that.$message.error(res.data.message);
          }
        }).catch((err) => {
          console.error(err);
          that.$message.error("操作失败");
        })
      });
    },
    saveItem() {
      let that = this;
      let url = base.api.dict.item.add.replace("{catalogId}", that.curDict.id);
      if (that.editDialog.mode === 'edit') {
        url = base.api.dict.item.edit;
      }
      that.$ajax.post(url, that.curItem).then(res => {
        if (res.data.status === 'success') {
          that.$message.success('保存成功');
          that.getData();
          that.editDialog.visible = false;
        } else {
          that.$message.error(res.data.message);
        }
      }).catch(err => {
        console.error(err);
        that.$message.error("操作失败");
      });
    },
    editItem(item) {
      let that = this;
      if (item.id) { // 编辑
        that.editDialog.mode = 'edit';
        that.curItem.id = item.id;
        that.curItem.itemName = item.itemName;
        that.curItem.itemDesc = item.itemDesc;
        that.curItem.itemCode = item.itemCode;
        that.curItem.sort = item.sort;
        that.curItem.catalogId = item.catalogId;
      } else { // 新增
        that.editDialog.mode = 'add';
        that.curItem.id = '';
        that.curItem.itemCode = '';
        that.curItem.itemName = '';
        that.curItem.itemIcon = '';
        that.curItem.itemDesc = '';
        that.curItem.itemCode = '';
        that.curItem.remark = '';
        that.curItem.sort = 0;
        that.curItem.catalogId = that.curDict.id;
      }
      that.editDialog.visible = true;
    },
    changeStatus(item) {
      let that = this;
      let targetStatus = (item.status + 1) % 2;
      that.$ajax.post(base.api.dict.item.updateStatus.replace("{id}", item.id).replace("{status}", targetStatus)).then(res => {
        if (res.data.status === 'success') {
          that.$message.success('操作成功');
          item.status = targetStatus;
        } else {
          that.$message.error(res.data.message);
        }
      }).catch(err => {
        console.error(err);
        that.$message.error("操作失败！");
      });
    }

  }
}
</script>

<style scoped lang="scss">
@import '../../../assets/css/admin.scss';
</style>